import { get } from 'epics/ajax';
import type { Observable } from 'epics/rxjs';
import * as qs from 'query-string';
import { APOLLO_STARGATE_CONTEXT_ROOT } from 'rest/constants';
import type { KnowledgeBaseSearchResult as FormattedKnowledgeBaseSearchResult } from 'state/ui/search';
import { getMeta } from '@atlassian/help-center-common-util/meta';
import type { KnowledgeBaseSearchResponse, KnowledgeArticleResponse, KbsQuery } from './types';

export const searchKbs = (kbsQuery: KbsQuery): Observable<FormattedKnowledgeBaseSearchResult> => {
    const { projectId, query, resultLimit, expandPortalName, categoryIds, portalIds, labels } = kbsQuery;
    const queryParams = {
        labels,
        portalIds,
        categoryIds,
        searchQuery: query,
        limit: resultLimit,
        expand: expandPortalName ? 'portal' : undefined,
    };

    const queryString = qs.stringify(queryParams);
    let uri;
    const activationId = getMeta('activation-id') as string;
    if (projectId) {
        uri = `${APOLLO_STARGATE_CONTEXT_ROOT}/${activationId}/api/jsm-portal/project/${projectId}/articles?${queryString}`;
    } else {
        uri = `${APOLLO_STARGATE_CONTEXT_ROOT}/${activationId}/api/jsm-portal/articles?${queryString}`;
    }

    return get(uri, { 'Content-Type': 'application/json' }).map((ajaxResponse) => {
        const result = ajaxResponse.response as KnowledgeBaseSearchResponse;
        return {
            ...result,
            articles: result.articles.map((article: KnowledgeArticleResponse) => ({
                id: article.articleId,
                name: article.articleTitle,
                articleSnippet: article.articleSnippet,
                pageVersion: article.articleVersion,
                score: article.snippetScore,
                isSmartSnippet: article.isSmartSnippet,
                linkedPortals: article.linkedPortals,
            })),
        };
    });
};
